/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BondAllocation
 */
export interface BondAllocation {
    /**
     * 
     * @type {number}
     * @memberof BondAllocation
     */
    optimizationId: number;
    /**
     * 
     * @type {string}
     * @memberof BondAllocation
     */
    pId: string;
    /**
     * 
     * @type {string}
     * @memberof BondAllocation
     */
    aC: string;
    /**
     * 
     * @type {string}
     * @memberof BondAllocation
     */
    symbol: string;
    /**
     * 
     * @type {string}
     * @memberof BondAllocation
     */
    side: string;
    /**
     * 
     * @type {number}
     * @memberof BondAllocation
     */
    quantity: number;
}

/**
 * Check if a given object implements the BondAllocation interface.
 */
export function instanceOfBondAllocation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "optimizationId" in value;
    isInstance = isInstance && "pId" in value;
    isInstance = isInstance && "aC" in value;
    isInstance = isInstance && "symbol" in value;
    isInstance = isInstance && "side" in value;
    isInstance = isInstance && "quantity" in value;

    return isInstance;
}

export function BondAllocationFromJSON(json: any): BondAllocation {
    return BondAllocationFromJSONTyped(json, false);
}

export function BondAllocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): BondAllocation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'optimizationId': json['optimization_id'],
        'pId': json['p_id'],
        'aC': json['a_c'],
        'symbol': json['symbol'],
        'side': json['side'],
        'quantity': json['quantity'],
    };
}

export function BondAllocationToJSON(value?: BondAllocation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'optimization_id': value.optimizationId,
        'p_id': value.pId,
        'a_c': value.aC,
        'symbol': value.symbol,
        'side': value.side,
        'quantity': value.quantity,
    };
}

